import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import helpers from '../utils/helpers'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {
      account: undefined,
      fullAccount: undefined,
      accessToken: '',
      dataToken: '',
      isRefreshing: false,
      refeshingCall: undefined,
      fullName: '',
      email: '',
      userId: 0,
      azureId: 0,
      userName: '',
      admin: false,
      serviceDesk: false
    },
    graphConfig: {},
    msalConfig: {
      auth: {
        clientId: '2a2d697e-8964-4a5b-aa72-aa6362f5e03a',
        authority: 'https://login.microsoftonline.com/46cec638-8a06-43fd-a7d7-8a626e13367f'
      },
      cache: {
        cacheLocation: 'localStorage'
      }
    },
    requestType: '',
    browserCheck: false
  },
  getters: {
    fullName: state => state.userInfo.fullName,
    userId: state => state.userInfo.userId,
    requestType: state => state.requestType,
    isAdmin: state => state.userInfo.admin,
    isServiceDesk: state => state.userInfo.serviceDesk,
    browserCheck: state => state.browserCheck,
    dataToken: state => state.userInfo.dataToken
  },
  mutations: {
    setAccessToken (state, token) {
      state.userInfo.accessToken = token
    },
    setDataToken (state, token) {
      state.userInfo.dataToken = token
      state.graphConfig = {
        headers: {
          Authorization: 'Bearer ' + token,
          ConsistencyLevel: 'eventual',
          ContentType: 'application/json'
        }
      }
    },
    setFullAccount (state, fullAccount) {
      state.userInfo.fullAccount = fullAccount
    },
    updateUserInfoFromAPI: (state, payload) => {
      state.userInfo.fullName = payload.data.fullName
      state.userInfo.email = payload.data.email
      state.userInfo.userId = payload.data.id
      state.userInfo.userName = payload.data.userName
      state.userInfo.admin = payload.data.isAdmin
      state.userInfo.serviceDesk = payload.data.isServiceDesk
      state.userInfo.azureId = payload.data.azureId
    },
    setRequestType: (state, type) => {
      state.requestType = type
    },
    setBrowserCheck: (state, checked) => {
      state.browserCheck = checked
      localStorage.setItem('browserCheck', checked)
    },
    setRefreshingState (state, refreshingState) {
      state.userInfo.isRefreshing = refreshingState
    },
    setRefreshingCall (state, refreshingCall) {
      state.userInfo.refreshingCall = refreshingCall
    }
  },
  actions: {
    async getAccessToken ({ commit, state }, msalInstance) {
      return new Promise((resolve, reject) => {
        let request = {
          scopes: ['api://2a2d697e-8964-4a5b-aa72-aa6362f5e03a/View']
        }
        if (state.userInfo.account) {
          msalInstance
            .acquireTokenSilent(request)
            .then(response => {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.accessToken
              commit('setAccessToken', response.accessToken)
              resolve(response)
            })
            .catch((e) => {
              if (e instanceof InteractionRequiredAuthError) {
                msalInstance
                  .acquireTokenPopup(request)
                  .then((response) => {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.accessToken
                    commit('setAccessToken', response.accessToken)
                    resolve(response)
                  })
                  .catch(e => {
                    commit('setAccessToken', undefined)
                    reject(e)
                  })
              }
              // commit('setAccessToken', undefined)
              // WSreject(e)
            })
        }
      })
    },
    async getDataToken ({ commit }, msalInstance) {
      return new Promise((resolve, reject) => {
        let request = { scopes: ['User.Read'] }
        msalInstance
          .acquireTokenSilent(request)
          .then((response) => {
            commit('setDataToken', response.accessToken)
            resolve(response.accessToken)
          })
          .catch((e) => {
            if (e instanceof InteractionRequiredAuthError) {
              msalInstance
                .acquireTokenPopup(request)
                .then((response) => {
                  commit('setDataToken', response.accessToken)
                })
                .catch(() => {
                  commit('setDataToken', undefined)
                })
            }
            // commit('setDataToken', undefined)
            // reject(e)
          })
      })
    },
    async getSingleFullAccountData ({ commit, state }, email) {
      return new Promise(resolve => {
        let call = 'https://graph.microsoft.com/v1.0/$batch'
        let batchCall
        let payload = { requests: [] }
        let users = []
        batchCall =
            "users?$filter=mail in ('" +
            encodeURIComponent(email.replace(/'/g, "''")) +
            "')&$select=onPremisesSamAccountName,givenName,surname,displayName,mail,jobTitle,officeLocation,accountEnabled"
        payload.requests.push({
          id: 0,
          method: 'GET',
          url: batchCall
        })
        helpers.doPost(users, call, payload, state).then(response => {
          commit('setFullAccount', response[0])
          resolve(response)
        })
      })
    },
    async getUserDetails ({ commit }, userName) {
      return new Promise((resolve, reject) => {
        let call = '/checkForUser/' + userName
        axios.get(call).then((response) => {
          commit('updateUserInfoFromAPI', response)
          resolve(response)
        })
          .catch((e) => {
            commit('updateUserInfoFromAPI', null)
            reject(e)
          })
      })
    }
  }
})
